import React from "react";
import { newLogo } from "../../assets/Images";
import { PlayIcon } from "@heroicons/react/24/solid";

export default function LoremSection() {
  const cards = Array.from({ length: 3 }, (_, i) => ({
    id: i + 1,
    title: "Lorem",
    description: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s.",
  }));

  return (
    <div className=" w-full max-w-6xl mx-auto px-6 py-12 mb-12 select-none">
      {/* Header */}
      <div className="text-left mb-10">
        <span className="text-secondary font-oswald text-base tracking-[0.2em] font-semibold uppercase block mb-1">
          Lorem :
        </span>
        <h3 className="text-3xl font-bold font-oswald text-white uppercase tracking-wide">
          Lorem Ipsum
        </h3>
      </div>

      {/* Grid of 3 Cards */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-10">
        {cards.map((card) => (
          <div
            key={card.id}
            className="group border-[0.7px] border-gray-200 relative bg-white rounded-xl shadow-xl flex flex-col transition-all duration-300 hover:-translate-y-2 pb-6"
            style={{ minHeight: "360px" }}
          >
            {/* Top: Black screen */}
            <div className="aspect-video w-full bg-black flex flex-col items-center justify-center p-4 rounded-t-xl relative overflow-hidden">
              <div className="absolute inset-0 bg-gradient-to-b from-transparent to-black/40"></div>
              <img
                src={newLogo}
                alt="BAB Logo"
                className="object-contain h-1/2 w-1/2 mb-2 transition-transform duration-500 group-hover:scale-105"
              />
              <span className="text-secondary font-oswald text-[10px] sm:text-xs tracking-widest font-semibold uppercase relative z-10">
                Coming Soon
              </span>
            </div>

            {/* Bottom: White card content */}
            <div className="p-6 text-left flex flex-col flex-grow relative bg-white rounded-b-xl">
              <h4 className="text-black font-outfit text-lg md:text-2xl font-bold mb-2">
                {card.title}
              </h4>
              <p className="text-gray-900 font-outfit text-xs sm:text-sm leading-relaxed mb-6">
                {card.description}
              </p>
            </div>

            {/* Overlapping Play Button */}
            <div className="absolute bottom-0 left-1/2 transform -translate-x-1/2 translate-y-1/2 w-12 h-12 rounded-full bg-secondary hover:bg-neutral-900 text-white hover:text-secondary-500 transition-all flex items-center justify-center shadow-lg hover:scale-105 cursor-pointer z-10">
              <PlayIcon className="w-5 h-5 translate-x-[1px]" />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
